import mainLogo from '../../images/Maggi/Maggi_logo_main_color.webp';
import squareLogo from '../../images/Maggi/Maggi_logo_main_color.webp';
import squareLogoSmall from '../../images/Maggi/Maggi_logo_main_color.webp';
import mainLogoWhite from '../../images/Maggi/Maggi_logo_main_white.webp';
import banner01 from '../../images/Maggi/Maggi_BG_01.webp';
import banner02 from '../../images/Maggi/Maggi_BG_02.webp';
import banner03 from '../../images/Maggi/Maggi_BG_03.webp';
import banner04 from '../../images/Maggi/Maggi_BG_04.webp';
import car123 from '../../images/Maggi/123_corollacross.jpg';
import box123 from '../../images/Maggi/123_Maggi.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Maggi',
    defaultStoreLink: 'pecas.maggimultimarcas.com.br',
    defaultContactEmail: 'pecas@maggimultimarcas.com.br',
    whatsappNumber: '11 94809 1353',
    CNPJ: '',
    CNPJname: '',
    CNPJaddress: '',
    launchDate: '15/08/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'volkswagen',
        'byd',
        'toyota',
        'citroen',
        'peugeot',
        // 'triumph',
        // 'harley',
        'fiat',
        'volvo',
        // 'land rover',
        'kia',
        'volvo',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "Globo Veículos Alto da XV",
        "Globo Nissan Alto da XV",
        "GLOBO JEEP CURITIBA",
        "Nissul Pelotas",
        "NISSUL GALA JEEP BAGÉ",
        "Iesa Ipiranga",
        "Itavema France Pinheiros",
        "ITVA FIAT NOVA IGUACU",
        "TOYOTA BOTAFOGO",
        "Iesa NISSAN LOG",
        "ITVA HYUNDAI CAMPO GRANDE",
        "NISSUL GALA HYUNDAI PELOTAS",
        "SAVOL VW CENTRO",
        "REVEMAR FIAT BELEM",
        "UNIQUE ANANINDEUA",
        "TROPICAL SÃO LUIS",
        "TROPICAL IMPERATRIZ",
        "Iesa VOLVO Azenha",
        "ITVA VOLVO VILA OLIMPIA",
        "BELCAR ASUKA",
        "Du Nort Belém - Marco",
        "IESA MOPAR",
        "SAVOL TOYOTA",
        "Iesa BMW NH",
        "BELCAR VW",
        "BELCAR FIAT",
        "REVEMAR VW",
        "SAVOL PSA",
        "SAVOL FIAT",
        "SAVOL KIA",
        "FENIX BELEM",
        "DISCAUTOL VW CARANDA",
        "REVEMAR VW PARAUAPEBAS",
        "REVEMAR FIAT - SÃO LUIS",
        "REVEMAR PSA BELEM",
        "FENIX PARAUAPEBAS",
        "TOYOTA GASTÃO VIDIGAL",
        "Itavema France Guarulhos",
        "Du Nort São Luís",
        "TROPICAL ANANINDEUA",
        "TROPICAL DOCA",
        "VECOL VW",
        "TEXAS",
        "Du Nort Marabá",
        "Du Nort Parauapebas",
        "TROPICAL MARABA",
        "TERRA SANTA",
        "Fórmula Curitiba - Parolin",
        "FABERGE KIA",
        "FABERGE VOLVO MOGI",
        "FABERGE PSA OFICINA",
        "RENAULT FABERGE",
        "FIAT FABERGE",
        "FABERGE AUDI MOGI",
        "GLOBO RENAULT SC",
        "GLOBO JEEP SC",
        "GLOBO FORD SC",
        "VIGORITO VW ATACADO",
        "VIGORITO NISSAN ATACADO",
        "VIGORITO KIA",
        "VIGORITO GM ATACADO",
        "BARI PONTA GROSSA HYUNDAI",
        "BARIGUI HYUNDAI SC",
        "BARIGUI NISSAN",
        "GLOBO FIAT SC",
        "NIX NISSAN BLUMENAU",
        "NIX NISSAN JOINVILLE",
        "UMUARAMA FIAT ARAGUAINA",
        "UMUARAMA FIAT PARAUAPEBAS",
        "UMUARAMA FIAT REDENCAO",
        "UMUARAMA TOYOTA ARAGUAINA",
        "UMUARAMA TOYOTA IMPERATRIZ",
        "UMUARAMA TOYOTA RIO VERDE",
        "UMUARAMA VW ARAGUAINA",
        "UMUARAMA VW ITUMBIARA",
        "UMUARAMA KIA",
        "UMUARAMA CITROEN RIO VERDE",
        "UMUARAMA TOYOTA CALDAS NOVAS",
        "UMUARAMA TOYOTA MINEIROS",
        "UMUARAMA TOYOTA ITUMBIARA",
        "RECREIO BH VW",
        "RECREIO RJ VW",
        'SULPAR SGA TOYOTA - HAUER',
        'SULPAR SGA TOYOTA - NITEROI',
        'VITORIAWAGEN SERRA',
        'UMUARAMA HARLEY GOIANIA',
        'DUVEL - VEICULOS CENTRO',
        "LUSON VW",
        "LUSON VW TARUMA",
        "Iesa NISSAN Canoas",
        "Iesa NISSAN Gravataí",
        "Iesa NISSAN NH",
        "Iesa NISSAN Osório",
        "Iesa NISSAN Tarso",
        "Iesa NISSAN Wenceslau",
        "Iesa JEEP Cachoeirinha",
        "Carmo Montes Claros",
        "Open Veículos Cascavel",
        "VETOR HYUNDAI CASCAVEL",
        "BRIZZA MITSUBISHI CASCAVEL",
        "SAINT-TROPEZ PEUGEOT SANTOS",
        "AKTA KIA",
        "EUROKRAFT VW NOVA FRIBURGO",
        "BARIGUI FIAT BLUMENAU",
        "BARIGUI TORRES UBERADA",
        "BARIGUI BLUSA VW",
        "BARIGUI CABRAL VW",
        "Fórmula Londrina",
        'APIA VW',
        "ITAVEMA BYD NOVA IGUACU",
        "AUDI CENTER TERESINA",
        'ORLY FIAT BETIM',
        "BARIGUI BMW MARINGÁ",
        "BARIGUI KIA CAMPINA SIQUEIRA",
        "BARIGUI CITROEN PARQUE",
        "Barigui FORD Estoques",
        "BARIGUI BYD - TARUMA",
        "BARIGUI VW - SAO JOSE (MATRIZ)",
        "UMUARAMA VW CATALAO",
        "JAPAN MOTOS MATRIZ",
        "JAPAN NISSAN TERESINA",
        "Via Paris Bairro dos Noivos",
        "ALEMANHA VW",
        "VIVA VW MACEIO",
        "NISSUL GALA JEEP PELOTAS",
        "BARIGUI PEUGEOT XV",
        "BARIGUI AUDI - LONDRINA",
        "ESTILO VW - POUSO ALEGRE",
        "LOVAT HYUNDAI - LONDRINA",
        "PROVENCE PEUGEOT-CITROEN",
        "BARIGUI JEEP - TORRES",
        "GLOBO NISSAN SC",
        "UMUARAMA HARLEY UBERLANDIA",
        "SAIKON HONDA GUARAPUAVA",
        "UMUARAMA KTM GOIANIA",
        "FARIA SÃO PAULO",
        "DOKAR VW - PINDAMONHANGABA",
        "RECREIO VW MG - MILA",
        "COMERI VW",
        "Barigui FORD Maringá",
        "INTERCONTINENTAL POA",
        "INTERCONTINENTAL CAXIAS",
        "DISCAUTOL PSA - AHO FRANCE",
        "BREITKOPF VW BLUMENAU",
        "MAZAM MOTORS HYUNDAI SETE LAGOAS",
        "TRIUMPH UBERLANDIA - UMUARAMA",
        "PAMPEIRO VW - SANTA MARIA",
        "AUDI CENTER - ALTO DA XV",
        "BEVEL VW - MARAU",
        "Gala Canoas",
        "Iesa NISSAN Wenceslau",
        "BELCAR MOTOS INDEPENDENCIA",
        "BARIGUI CAOA CHERY - SAO JOSE DOS PINHAIS",
        "NISSUL CAOA CHERY PELOTAS",
        "CARRERA ACELERA VW",
        "SMAFF BERLIM",
        "SMAFF IMPORT ASA NORTE",
        "ORLY VALORE FIAT - ITAGUAI",
        "PAMPA VW MATRIZ",
        "RECOL VEICULOS",
        "CAMVEL PEREQUÊ",
        "CAMVEL BALNEÁRIO",
        "PROMENAC",
        "MOTO & CIA - LUZIÂNIA",
        "BARIGUI CAOA CHERY - BLUMENAU",
        "CARAIGÁ VW MORUMBI",
        "CARAIGÁ AUDI MORUMBI",
    ],

    disabledSellers: [],

    useMktNames: true,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        // {
        //     name: 'Acessórios',
        //     img: 'tabAcessorios',
        //     products: SliderProducts.Acessorios
        // },
        {
            name: 'Luzes',
            img: 'tabLuzes',
            products: SliderProducts.Luzes
        },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogoSmall,
    bannerImg01: mainLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    bannerBrands: '',
    aboutUsBg: banner04,


    car123: car123,
    box123: box123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu veículo. Peças <mark>genuínas</mark> direto das concessionárias do <mark>Grupo Maggi</mark>.',

    aboutUs: {
        title: 'Quem somos',
        content: [
            'A Maggi Fiat foi fundada em Itu (SP) no ano de 1976, e 5 anos depois foi adquirida pelos acionistas atuais, que mantiveram o nome do seu fundador, MAGGI, em sua identidade.',
            'Na linha automotiva, está presente com as melhores marcas: Fiat, Toyota, Volkswagen (carros e caminhões), Citroën, Harley-Davidson, Volvo, Jaguar, Land Rover, Triumph, BYD, Can-AM e Sea-Doo.',
            'Também faz parte do grupo, o Consórcio Maggi de imóveis, automóveis e caminhões; o Consórcio Nacional Massey Ferguson e o Consórcio Nacional Valtra de máquinas agrícolas.',
            'Além disso, atua em outros segmentos como; Maggi Corretora de Seguros, Maggi Mobility, Maggi Empreendimentos e no ramo hoteleiro com o Itu Plaza Hotel.',
            'São mais de 40 anos no mercado com cerca de 1.700 colaboradores dedicados em prestar um serviço de qualidade. Hoje, denominada como Empresas Maggi, está presente em mais de 15 cidades do Estado de São Paulo, possui atendimento em todo território nacional e atua nos mais diversos segmentos.'
        ],
        link: 'https://empresasmaggi.com.br/quem-somos',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/empresasmaggi/',
        Facebook: 'https://www.facebook.com/empresasmaggi',
        LinkedIn: 'https://br.linkedin.com/company/empresas-maggi',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}